import { set } from 'lodash-es';
import {
  ChildCareAgeGroups,
  Language,
  SEOChildCareQualifications,
  HousekeepingService,
  SEOSeniorCareSubServices,
  ActivityParticipationType,
  DayOfWeek,
} from '@/__generated__/globalTypes';

export const loadFilters = () => {
  try {
    const serializedState = localStorage.getItem('filters');
    if (serializedState === null) {
      return null;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return null;
  }
};

export const saveFilters = (
  filter: {
    ages?: string[];
    availability?: string | null;
    radius?:
      | { unit: string; value: number }
      | { unit: string; value: number }
      | { unit: string; value: number }
      | { unit: string; value: number };
    zipcode?: string;
    hourlyRate?: string;
    schedule?: string[];
    services?: string[];
    jobType?: string;
    experienceWithAges?: string[];
    yearsOfExperience?: number | null;
    hours?: {
      startTime: string;
      endTime: string;
      isOvernight?: boolean;
    };
    seniorCareSubServices?: SEOSeniorCareSubServices[] | null;
    certifiedNursingAssistant?: boolean | null;
    seniorCareCprTrained?: boolean | null;
    homeHealthAid?: boolean | null;
    registeredNurse?: boolean | null;
    languages?: Language[] | null;
    childCareAgeGroups?: ChildCareAgeGroups[] | null;
    childCareQualifications?: SEOChildCareQualifications[] | null;
    housekeepingSubServices?: HousekeepingService[] | null;
    activityParticipationType?: ActivityParticipationType[] | null;
    activityDaysOfWeek?: DayOfWeek[] | null;
    activityDates?: string[] | null;
  },
  __callback?: Function
) => {
  try {
    const storedFilters = localStorage.getItem('filters');
    let filterObj = JSON.parse(storedFilters || '{}');

    filterObj = { ...filterObj, ...filter };

    const serializedState = JSON.stringify(filterObj);
    localStorage.setItem('filters', serializedState);
    if (__callback) {
      __callback();
    }
  } catch (err) {
    // return undefined;
  }
};

export const updateFilterField = (filterName: string, filterValue: any) => {
  try {
    const storedFilters = localStorage.getItem('filters');
    const filterObj = JSON.parse(storedFilters || '{}');
    set(filterObj, filterName, filterValue);

    const serializedState = JSON.stringify(filterObj);
    localStorage.setItem('filters', serializedState);
  } catch (err) {
    // return undefined;
  }
};

export const clearFilters = () => {
  try {
    localStorage.removeItem('filters');
  } catch (err) {
    // return undefined;
  }
};

export const removeFilter = (key: any) => {
  try {
    const storedFilters = localStorage.getItem('filters');
    const filterObj = JSON.parse(storedFilters || '{}');

    delete filterObj[key];

    const serializedState = JSON.stringify(filterObj);
    localStorage.setItem('filters', serializedState);
  } catch (err) {
    // return undefined;
  }
};
